<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d-flex align-items--center direction--column">
        <dara-icon size="xxl" icon="file-earmark-x" />
        <dara-header>{{ $t('you-dont-have-permission-to-access-this-article') }}</dara-header>
        <dara-p>
          {{ $t('the-article-is-personal-or-exclusive-of-a-department-other-than-yours') }}
        </dara-p>
        <br>
        <dara-button theme="primary" @click="goToBasePage()">
          {{ $t('return-to-page') }}
        </dara-button>
      </div>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { goToBasePage } from '@/router/route.service';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraArticleDeniedPage',
  components: {
    DaraSingleContentLayout,
  },
  methods: {
    goToBasePage,
  },
};
</script>
